/* eslint-disable no-console */
export default function safeSaga(sagaGeneratorFunc) {
  // eslint-disable-next-line func-names
  return function* (...args) {
    try {
      yield* sagaGeneratorFunc(...args);
    } catch (error) {
      console.log(
        '*** Uncaught Saga Error: sagaGeneratorFunc: ',
        JSON.stringify(sagaGeneratorFunc)
      );
      console.log('** Uncaught Saga Error:', error);
    }
  };
}
